
import { ProvisionItem } from "../provisionitem";

export class StructureControlRequest {
    PDVersion: string;
    CSpec: Array<ProvisionItem>;
    LockedFPCs: Array<ProvisionItem>;
    IgnoreCO: boolean;    
    OnlyIndicateStoppingStructureErrors: boolean;
    StartObject: string; 
    TimeValidity: boolean; 

}
